import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { UserRolePermissionService } from '../../../core/services/user-role-permission.service';
import { IconComponent, IconName } from '../icon/icon.component';

export interface BottomNavTab {
  label: string;
  icon: IconName;
  /** Navigate to this route on tap. Mutually exclusive with `action`. */
  route?: string;
  /** Emit a `tabAction` with this key on tap (e.g. `'more'` to open the sidenav). Mutually exclusive with `route`. */
  action?: string;
  /** Permission required to show this tab, e.g. 'Consignor:View'. Omit to always show. */
  permission?: string;
}

/**
 * Mobile bottom navigation. Hidden on viewports ≥1024px via CSS.
 */
@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [IconComponent, RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss'
})
export class BottomNavComponent {
  private readonly userRolePermission = inject(UserRolePermissionService);

  readonly tabs = input<BottomNavTab[]>([]);
  readonly tabAction = output<string>();

  protected onAction(action: string): void {
    this.tabAction.emit(action);
  }

  protected isVisible(tab: BottomNavTab): boolean {
    return !tab.permission || this.userRolePermission.hasPermission(tab.permission);
  }
}
